import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
} from "../../../components/card/card";
import ImageViewer from "../../../components/ImageViewer";
import { printDate, printLocation } from "../../../utils/helper";
import React, { useState, useEffect } from "react";
import {
  asset,
  companyProfile,
  customer,
  inventory,
  part,
  vendor,
} from "../../../api";
import { parserAPI } from "../../../utils/parser";
import { toast } from "react-toastify";
import { renderImage } from "../../../utils/helper.jsx";
import Styles from "./index.modules.css";
import NormalSelect from "../../../components/form/HorizontalNormalSelect/index.jsx";
import { Form } from "react-bootstrap";
import * as XLSX from "xlsx";
import LoadingIndicator from "../../../components/LoadingIndicator/index.jsx";

function ImportPage() {
  const [loading, setLoading] = useState(false);
  const [selectedData, setSelectedData] = useState("");
  const [file, setFile] = useState();

  const handleFileUpload = async () => {
    try {
      if (!selectedData) {
        toast.error("Please select a Data set field!");
        return;
      }

      if (!file || !file.target.files[0]) {
        toast.error("Please select a file before importing!");
        return;
      }
      setLoading(true);

      await new Promise((res, rej) => {
        const selectedFile = file.target.files[0]; // Get the first uploaded file

        const reader = new FileReader();
        reader.onload = async (evt) => {
          const binaryStr = evt.target.result;
          const wb = XLSX.read(binaryStr, { type: "binary" });

          // Get the first sheet from the workbook
          const ws = wb.Sheets[wb.SheetNames[0]];

          // Convert sheet to JSON format
          const jsonData = XLSX.utils.sheet_to_json(ws);

          let result;
          if (selectedData == "Part") {
            result = await part.import(jsonData);
          }
          if (selectedData == "Asset") {
            result = await asset.import(jsonData);
          }
          if (selectedData == "Inventory") {
            result = await inventory.import(jsonData);
          }

          if (selectedData == "Vendor") {
            result = await vendor.import(jsonData);
          }

          if (selectedData == "Customer") {
            result = await customer.import(jsonData);
          }

          if (result.ok) {
            toast.success("Succesfully import " + selectedData + " data set");
            setSelectedData("");
            setFile(null);
            file.target.value = null;
            res(true);
          } else {
            toast.error("Something went wrong!");
          }
        };
        reader.readAsBinaryString(selectedFile);
      });
    } catch (e) {
      console.log(e);
      toast.error("Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  const downloadTemplate = () => {
    window.open("/template/" + selectedData + ".xlsx");
  };

  return (
    <div>
      <LoadingIndicator open={loading} />
      <div className="d-flex align-items-center mb-3">
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="#/">Setup</a>
            </li>
            <li className="breadcrumb-item active">Import Data</li>
          </ol>
          <h1 className="page-header mb-0">Import Data</h1>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-4">
          <Card>
            <CardBody>
              <NormalSelect
                list={[
                  {
                    name: "Asset",
                    value: "asset",
                  },
                  {
                    name: "Part",
                    value: "part",
                  },
                  {
                    name: "Inventory",
                    value: "inventory",
                  },
                  {
                    name: "Vendor",
                    value: "vendor",
                  },
                  {
                    name: "Customer",
                    value: "customer",
                  },
                ]}
                value={selectedData}
                label={"Data Set"}
                required
                onchange={(e) => setSelectedData(e.target.value)}
              />

              {selectedData && (
                <div className="btn btn-theme mb-3" onClick={downloadTemplate}>
                  Download {selectedData} Template
                </div>
              )}

              <Form.Group controlId="formFile" className="mb-3">
                <Form.Label>
                  Import File (Excel/CSV) <span className="text-danger">*</span>{" "}
                </Form.Label>
                <Form.Control
                  type="file"
                  onChange={setFile}
                  accept=".csv,.xlsx"
                />
              </Form.Group>

              <button
                onClick={handleFileUpload}
                className="btn btn-outline-theme"
              >
                Import
              </button>
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  );
}
export default ImportPage;
